import { RefObject } from 'react';

import { Float, Position } from './find-postion-env';
import findLeft from './find-left/find-left';
import findTop from './find-top/find-top';

interface Params {
  containerRef?: RefObject<HTMLElement>;
  float?: Float;
  triggerPosition?: Position;
  triggerRef?: RefObject<HTMLElement>;
}

const findPosition = (
  targetRef: RefObject<HTMLElement> | undefined,
  { containerRef, float = 'left', triggerPosition, triggerRef }: Params = {},
): Position => {
  const containerRect = containerRef?.current?.getBoundingClientRect();

  const targetRect = targetRef?.current?.getBoundingClientRect();
  const size = targetRect || { height: 0, width: 0 };

  const triggerRect = triggerRef?.current?.getBoundingClientRect();
  const tp = triggerPosition || (triggerRect ?? { left: 0, top: 0 });

  const left = findLeft(containerRect, float, size, tp);
  const top = findTop(containerRect, size, tp);

  return { top, left };
};

export default findPosition;
